import { Injectable } from '@angular/core';
import writeXlsxFile from 'write-excel-file/browser';

@Injectable({
  providedIn: 'root'
})
export class XlsxService {

  constructor() { }

  async saveExcel(table: any, name: string) {
    const htmlTable: HTMLTableElement | null =
      table instanceof HTMLTableElement ? table :
      table?.nativeElement instanceof HTMLTableElement ? table.nativeElement :
      null;

    if (!htmlTable) {
      throw new Error('saveExcel expects an HTMLTableElement (or ElementRef<HTMLTableElement>)');
    }

    const data = Array.from(htmlTable.rows).map((row) =>
      Array.from(row.cells)
        .slice(1) // match previous behavior: delete first column
        .map((cell) => ({ value: (cell.textContent ?? '').trim() }))
    );

    await writeXlsxFile(data).toFile(`${name}.xlsx`);
  }

  async saveExcelData(excelData: any[], name: string) {
    const rows = Array.isArray(excelData) ? excelData : [];
    const headers = rows.length > 0 ? Object.keys(rows[0]) : [];

    const data: { value: any }[][] = [];

    if (headers.length > 0) {
      data.push(headers.map((h) => ({ value: h })));
      for (const item of rows) {
        data.push(headers.map((h) => ({ value: item?.[h] ?? '' })));
      }
    }

    await writeXlsxFile(data).toFile(`${name}.xlsx`);
  }

}
